module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "basket-list-items"
  }, [_c('table', {
    staticClass: "table table-detail"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("basket.labelPrice")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("basket.labelQuantity")))]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showUnit),
      expression: "showUnit"
    }]
  }), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showUnit),
      expression: "showUnit"
    }]
  }, [_vm._v(_vm._s(_vm.$t("basket.labelUnit")))])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "table-items",
    attrs: {
      "colspan": "6"
    }
  }, _vm._l((_vm.datasListBaskets.items), function(itemBasket) {
    return _c('BasketListItem', {
      key: itemBasket.id,
      attrs: {
        "item": itemBasket,
        "showUnit": _vm.showUnit
      }
    })
  }))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e860965a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/basket/BasketList.vue
// module id = 3390
// module chunks = 0